'use client';
import { useLocalStorageState } from 'ahooks';
import { getUserEveryDayCredit } from '@/app/apis';
import { toast } from '@/app/components/ui/use-toast';
import { useStore } from '@/app/providers/store';
import { useCredits } from './use-credits';
import { useFetch } from './use-fetch';

export const useGetEveryDayCredit = () => {
  const { userInfo } = useStore((state) => ({
    userInfo: state.userInfo,
  }));

  const [lastLoginTime, setLastLoginTime] = useLocalStorageState<string>(
    `every_day_credit_last_login_time_${userInfo?.id}`,
    {
      defaultValue: '',
    },
  );

  const { updateCredits } = useCredits();

  const { runAsync: runGetEveryDayCreditAsync } = useFetch(() => getUserEveryDayCredit({}), {
    manual: true,
    onSuccess: ({ data, error }) => {
      if (error) {
        toast({
          type: 'error',
          message: error.message,
        });
        return;
      }
      setLastLoginTime(new Date().toLocaleDateString());
      if (data?.credit && data.credit > 0) {
        updateCredits();
        return;
      }
    },
  });

  const getEveryDayCreditNumber = async () => {
    if (lastLoginTime === new Date().toLocaleDateString()) {
      return 0;
    }
    const response = await runGetEveryDayCreditAsync();
    return response.data?.credit || 0;
  };

  return { getEveryDayCreditNumber, runGetEveryDayCreditAsync };
};
